import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/service_time_picker.template.htm';
import 'dhtmlxMessage';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import RowPicker from 'text-loader!../templates/row_time_picker.template.htm';
import RowAddPicker from 'text-loader!../templates/row_add_time_picker.template.htm';
import i18n  from "l10n";

export default GenericView.extend({
    el: '#service_time_picker',
    tagName: 'div',
	template: Handlebars.compile(Template),
	rowPicker: Handlebars.compile(RowPicker),
	rowAddPicker: Handlebars.compile(RowAddPicker),
	superInitialize: GenericView.prototype.initialize,
	serviceTimes: null,
	daysCount: 0,
	errorArray: [],
	initialize: function (options) {
		this.serviceTimes = options.serviceTimes;
		this.render();

	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();
		//this.$el.html(this.template());

		this.initServiceTimes();

	},
	events: {
		"click #add_new_work_day": "addNewWorkDay",
		"click .remove-day": "removeDay",
		"input .starting input": "validateStartingTime",
		"input .ending input": "validateEndingTime",
		"change .starting select": function(e) {
		    $($(e.currentTarget).parent().find("input")[0]).val($(e.currentTarget).val());
		},
        "change .ending select": function(e) {
            $($(e.currentTarget).parent().find("input")[0]).val($(e.currentTarget).val());
        },
		"change .period-select": "validateWorkingDays"
	},
	validateRowOnChange: function(event)
	{
		var input = 0;
		if(event.length)
			input = event;
		else
			input = $(event.currentTarget);

		this.validate(input.data("index"));
	},
	initServiceTimes: function()
	{
		if(!this.serviceTimes || this.serviceTimes.length == 0)
		{
			this.addServiceTime();
			this.addMore();
			return;
		}

		for(var index in this.serviceTimes)
		{
			var obj = this.serviceTimes[index];
			this.addServiceTime(obj);

		}
		this.addMore();
	},
	addServiceTime: function(obj)
	{
		if(obj)
		{
			obj.serviceStartTime = obj.serviceStartTime.slice(0,-3);
			obj.serviceEndTime = obj.serviceEndTime.slice(0,-3);
		}

		this.$el.append(this.rowPicker($.extend( obj, { index: this.daysCount} )));
		this.initializeTimepicker(this.daysCount);
		if( this.daysCount == 0)
			$("#serviceTimeRow"+this.daysCount+" button.remove-day").hide();
		this.daysCount ++;
	},
	addMore: function()
	{
		this.$el.append(this.rowAddPicker());
	},
	addNewWorkDay: function(event)
	{
		var rowParent = $(event.currentTarget).parent().parent();
		rowParent.remove();
		this.addServiceTime();
		this.addMore();
	},
	removeDay: function(event)
	{
		var element = $(event.currentTarget)
		$('#serviceTimeRow'+element.data("remove-index")).remove();

	},
	initializeTimepicker: function(index)
	{
		var self = this;
		var starting = $('#serviceTimeRow'+index+' .starting input');
	 	starting.timepicker({
			timeFormat: 'HH:mm',
			interval: 60,
			minTime: '00:00',
			maxTime: '23:59',
			firstTime: true,
			dropdown: true,
			scrollbar: true,
			dynamic: false,
			change: function(event)
			{
				self.validateStartingTime(this);
			}
		});

		var ending = $('#serviceTimeRow'+index+' .ending input');
		ending.timepicker({
			timeFormat: 'HH:mm',
			interval: 60,
			minTime: '00:00',
			firstTime: true,
			maxTime: '23:59',
			dropdown: true,
			scrollbar: true,
			dynamic: false,
			change: function(event)
			{
				self.validateEndingTime(this);
			}
		});

		//defaultTime: starting,
		//startTime: '00:00',

		/*$('#active_times_close input').timepicker({
			timeFormat: 'HH:mm',
			interval: 60,
			minTime: '07:00',
			maxTime: '21:00',
			defaultTime: '07:00',
			startTime: '07:00',
			dropdown: true,
			dynamic: false,
			scrollbar: true,

		});*/
	},
	hasError: function()
	{
		var self = this;
		var has_error = false;
		var allServices = $(".time-picker-container");
		allServices.each(function()
		{
			has_error = self.validate($(this).data("index")) || has_error;
		});
		//console.info("has error"+ has_error);
		//this.getData(7);
		return has_error;
	},
	validateWorkingDays: function(event) {
	    var input = 0;
        if(event.length)
            input = event;
        else
            input = $(event.currentTarget);

        var index =  input.data("index");
        var element = $('#serviceTimeRow' + index);

        var has_error = false;
        var errorSpan = element.find("span.time-picker-error");

        var day = element.find("select");

        var text = "";
        if(day.val() == null)
        {
            this.addError(index, i18n.t("timepicker.choose_option"));
            has_error = true;
        } else {
            this.removeError(index, i18n.t("timepicker.choose_option"));
        }

        return has_error;
	},
	validateStartingTime: function(event)  {
	    var input = 0;
        if(event.length)
            input = event;
        else
            input = $(event.currentTarget);

        var index =  input.data("index");
        var element = $('#serviceTimeRow' + index);

        var has_error = false;
        var errorSpan = element.find("span.time-picker-error");

        var starting = element.find(".starting input");

        var text = "";
        if(!this.isValidTime(starting.val()))
        {
            this.addError(index, i18n.t("timepicker.invalid_starting"));
            has_error = true;
        } else {
            this.removeError(index, i18n.t("timepicker.invalid_starting"));
        }

        return has_error;
	},
	validateEndingTime: function(event)  {
        var input = 0;
        if(event.length)
            input = event;
        else
            input = $(event.currentTarget);

        var index =  input.data("index");
        var element = $('#serviceTimeRow' + index);

        var has_error = false;
        var errorSpan = element.find("span.time-picker-error");

        var ending = element.find(".ending input");

        var text = "";
        if(!this.isValidTime(ending.val()))
		{
			this.addError(index, i18n.t("timepicker.invalid_ending"));
			has_error = true;
		} else {
		    this.removeError(index, i18n.t("timepicker.invalid_ending"));
		}

		return has_error;
	},
	validate: function(index)
	{
		var has_error = false;

		var element = $('#serviceTimeRow' + index);
		var starting = element.find(".starting input");
		var ending = element.find(".ending input");
		var day = element.find("select");
		var errorSpan = element.find("span.time-picker-error");

		var text = "";
		if(day.val() == null)
		{
			this.addError(index, i18n.t("timepicker.choose_option"));
			has_error = true;
		} else {
		    this.removeError(index, i18n.t("timepicker.choose_option"));
		}

		if(!this.isValidTime(starting.val()))
		{
			this.addError(index, i18n.t("timepicker.invalid_starting"));
			has_error = true;
		} else {
		    this.removeError(index, i18n.t("timepicker.invalid_starting"));
		}

		if(!this.isValidTime(ending.val()))
		{
			this.addError(index, i18n.t("timepicker.invalid_ending"));
			has_error = true;
		} else {
		    this.removeError(index, i18n.t("timepicker.invalid_ending"));
		}

		this.displayError(index);
		return has_error;
	},
	isValidTime: function(time)
	{
  		var pattern = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
		if(pattern.test(time))
		{
			return true;
		}
		return false;
	},
	indexToDayOfWeek: function(index)
	{
		switch(Number(index))
		{
			case 0:
				return "Monday";
			case 1:
				return "Tuesday";
			case 2:
				return "Wednesday";
			case 3:
				return "Thursday";
			case 4:
				return "Friday";
			case 5:
				return "Saturday";
			case 6:
				return "Sunday";
			case 7:
				return "Weekdays";
			case 8:
				return "Weekend";
			case 9:
                return "AllDays";
			default:
				return "Weekend";
		}
	},
	getData: function(queueId)
	{
		var self = this;

		var servicesTimes = [];
		var allServices = $(".time-picker-container");
		allServices.each(function()
		{

			var element = $(this);
			var index = element.data("index")
			var starting = element.find(".starting input");
			var ending = element.find(".ending input");
			var day = element.find("select");

			var obj =
			{
				id: element.data("service-id"),
				queueId: queueId,
				dayOfWeek: self.indexToDayOfWeek(day.val()),
				serviceStartTime: starting.val()+":00",
				serviceEndTime: ending.val()+":00",
			};

			servicesTimes = servicesTimes.concat([obj]);

		});

		//console.info(servicesTimes);
		return servicesTimes;

	},
	addError: function(index, text) {
        if(this.errorArray[index]) {

            for(var i = 0; i < this.errorArray[index].length; i++) {
                if(this.errorArray[index][i] == text) {

                    return;
                }
            }
        } else {
            this.errorArray[index] = new Array();
        }

        this.errorArray[index][this.errorArray[index].length] = text;
        this.displayError(index);

	},
	displayError: function(index) {


		if(this.errorArray[index])
		{
			var element = $('#serviceTimeRow' + index);
			var errorSpan = element.find("span.time-picker-error");

			var text = "" ;
			for(var i = 0; i < this.errorArray[index].length; i++) {
				if(this.errorArray[index][i])
					text = text + "" + this.errorArray[index][i] + ", " ;
			}
			errorSpan.html(text.slice(0, -2));
		}
	},
	removeError: function(index, text) {
        var arrayIndex = -1;

        if(this.errorArray[index]) {

            for(var i = 0; i < this.errorArray[index].length; i++) {
                if(this.errorArray[index][i] == text) {
                    arrayIndex = i;
                    break;
                }
            }
        }
        if(arrayIndex > -1) {
            delete this.errorArray[index][arrayIndex];
            this.displayError(index);
        }
	},
	clearView: function()
	{
		this.$el.html("");
		this.serviceTimes = null;
		this.daysCount = 0;
	}
});

